import type { Doc } from "building-types/doc";
import { DocEntityNodeBase, type DocEntityNodeSource } from "../docEntityNodeBase";
import type { DocEntityTypeToHandleType } from "../docEntityTypeToHandleType";

/**
 * Default concrete implementation of DocEntityNodeBase.
 * Used as a fallback for entity types that don't have specific implementations.
 */
export default class DefaultDocEntityNode<T extends keyof DocEntityTypeToHandleType> extends DocEntityNodeBase<T> {
  constructor(handle: DocEntityTypeToHandleType[T], doc: Doc, docEntityNodeSource: DocEntityNodeSource) {
    super(handle, doc, docEntityNodeSource);
  }
}
